export const clubCustomers = state => state.customers.filter(t => t.type === 'club')
export const customers = state => state.customers
export const pickerOptions = state => state.pickerOptions
export const orgTypes = state => state.orgTypes
export const orgClasses = state => state.orgClasses
export const modeList = state => state.modeList



// WEBPACK FOOTER //
// ./src/store/getters.js